import classNames from 'classnames';
import React from 'react';

import styles from './Muted.module.scss';



type Props = {
	/** Mutad value */
	children: React.ReactNode,
	/** Enable ellpsis support (… will be color of this component) to prevent overflowing */
	ellipsis?: boolean,
};

const Muted: React.FC<Props> = (props) => {
	const {
		children,
		ellipsis,
	} = props;

	const componentClasses = classNames({
		[styles.component]: true,
		[styles.isWithEllipsis]: ellipsis,
	});

	return (
		<span className={componentClasses}>
			{children}
		</span>
	);
};



export default Muted;
